import { render, staticRenderFns } from "./AuthGrant.vue?vue&type=template&id=10b9db1b&scoped=true"
import script from "./AuthGrant.vue?vue&type=script&lang=js"
export * from "./AuthGrant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b9db1b",
  null
  
)

export default component.exports